  <template>
  <div class="card-body">
	<div v-if="success != ''" class="alert alert-success" role="alert"> {{success}} </div>
	<form @submit="formSubmit" enctype="multipart/form-data">
	  <input class="input" type="hidden" v-model="id" >
	  <div class="form-group row">
		<label for="status"  class="col-md-4 col-form-label">Month</label>
		<div class="col-md-12">
		  <select id="month" v-model="month" name="Month" required class="form-control ">
			<option value="1">January</option>
			<option value="2">February</option>
			<option value="3">March</option>
			<option value="4">April</option>
			<option value="5">May</option>
			<option value="6">June</option>
			<option value="7">July</option>
			<option value="8">August</option>
			<option value="9">September</option>
			<option value="10">October</option>
			<option value="11">November</option>
			<option value="12">December</option>
		  </select>
		</div>
	  </div>
	  <div class="form-group row">
		<label for="name" class="col-md-4 col-form-label">Year</label>
		<div class="col-md-12">
		  <input id="year" type="text" class="form-control" v-model="year" required name="year" placeholder="Year" >
		</div>
	  </div>
	  <div class="form-group">
		<div class="col-md-6">
		  <button class="btn btn-primary btn-full-width">Submit</button>
		</div>
	  </div>
	</form>
  </div>
  </template> 
  <script>
	  export default {
		  mounted() {
			  console.log('Challan started..');   
			  console.log(this.componentdata);  
		  },
		  props: [],
				 
   
		  data() {
			  
			  return {
				  
				  success: '',
				  id: '',
				  month: '',
				  year: '',
				  
			  }
		  },
		  
		  methods:{
			  
  
			  formSubmit(e) {
  
				  e.preventDefault();
  
				  let currentObj = this;
  
   
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
   
  
				  let formData = new FormData();
  
				  axios.get(this.$api_url+'/salary-slips-company/'+this.month+'/'+this.year+'/0', formData, config)
  
				  .then(function (response) {
  
					  currentObj.success = response.data.success;
  
				  })
  
				  .catch(function (error) {
  
					  currentObj.output = error;
  
				  });
  
			  }
  
  
		  },
		  created: function(){
		  
		
		  }
	  }
  </script>